import { Component, EventEmitter, Input, Output, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TiktokGalleryService } from 'src/app/services/tiktok-gallery.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-tiktok-gallery',
  templateUrl: './tiktok-gallery.component.html',
  styleUrls: ['./tiktok-gallery.component.scss'],
  providers: [MessageService]
})
export class TiktokGalleryComponent implements OnInit, OnChanges {
  @Input() showContent = true;
  @Output() mediaResults = new EventEmitter<any[]>();
  @Input() selectedItems: any[] = [];
  @Output() selectedItemsChange = new EventEmitter<any[]>();
  @Input() isFeed = false;
  @Input() showAutoPublish = false;

  @Input() showConectAccount = false;
  @Output() showConectAccountChange = new EventEmitter<boolean>();

  tiktokAccountsOptions: any[] = [];
  tiktokVideos: any[] = [];
  formattedTikTokVideos: any[] = [];
  tiktokCursor?: number;
  pageSizeTikTok = 20; // teto real da API do TikTok (v2/video/list, max_count máx. 20)
  hasMoreTikTokVideos = false;
  hasSearchedTikTok = false;
  displayAguarde = false;

  // Para o tabMenu (mesmo que só tenha 1 aba)
  tabs = [{ label: 'Mídias' }];
  activeTab = this.tabs[0];

  // Para dialog de post ("ver mais")
  postDialogVisible = false;
  selectedPost: any = null;

  @Input() autoPublish = false; // recebe valor inicial (se o pai quiser controlar)
  @Output() autoPublishChange = new EventEmitter<boolean>(); // notifica mudanças para o pai

  // Sempre que mudar o valor do switch:
  onToggleAutoPublish(newValue: boolean) {
    this.autoPublish = newValue;
    this.autoPublishChange.emit(newValue); // notifica o pai
  }


  getMainText(): string {
    if (this.showConectAccount && !this.displayAguarde) {
      return 'Conecte uma conta do TikTok para começar';
    }
    if (!this.showConectAccount && !this.displayAguarde) {
      return 'Selecione uma conta';
    }
    // Adicione outras condições se necessário...
    return '';
  }

  constructor(
    private tiktokService: TiktokGalleryService,
    private errorHandler: ErrorHandlerService,
    private sanitizer: DomSanitizer,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.loadTikTokAccounts();
  }

  @Input() selectedTikTokOpenId?: string;
  @Output() selectedTikTokOpenIdChange = new EventEmitter<string>();

  onSelectTikTokAccount(id: string) {
    if (id === 'add_account') {
      this.conectTikTok();
      return;
    }

    this.selectedTikTokOpenId = id;
    this.selectedTikTokOpenIdChange.emit(id);
  }
  @Output() connectTikTok = new EventEmitter<void>();

  conectTikTok() {
    this.connectTikTok.emit();
  }


  loadTikTokAccounts() {
    this.displayAguarde = true;
    this.tiktokService.getAccounts().subscribe({
      next: (accs) => {
        this.tiktokAccountsOptions = accs.map((a: any) => ({
          label: a.username || a.name || a.id,
          value: a.id,
          picture: a.picture || 'assets/avatar-placeholder.png'
        }));
        if (this.tiktokAccountsOptions.length && !this.selectedTikTokOpenId) {
          this.selectedTikTokOpenId = this.tiktokAccountsOptions[0].value;
          this.showConectAccount = false;
        } else if (!this.tiktokAccountsOptions.length) {
          this.showConectAccount = true;
        }

        if (!this.showConectAccount) {
          this.tiktokAccountsOptions.push({
            id: null,
            label: 'Adicionar uma conta',
            value: 'add_account',
            picture: 'pi pi-plus'
          });
        }

        this.showConectAccountChange.emit(this.showConectAccount);
        this.displayAguarde = false;
      },
      error: () => {
        this.displayAguarde = false;
        this.showConectAccount = true;
        this.showConectAccountChange.emit(this.showConectAccount);
      }
    });
  }

  LoadSearching: boolean = false;
  loadMoreTikTokVideos(reset = false) {
    if (!this.selectedTikTokOpenId) return;
    if (reset) {
      this.tiktokVideos = [];
      this.tiktokCursor = undefined;
      this.hasMoreTikTokVideos = false;
      this.hasSearchedTikTok = false;
      this.formattedTikTokVideos = [];
    }
    this.LoadSearching = true;
    this.tiktokService.listTikTokVideos(this.selectedTikTokOpenId, this.pageSizeTikTok, this.tiktokCursor?.toString())
      .subscribe({
        next: (res: any) => {
          const profile = res.profile || {};
          const tiktokName = profile.display_name || profile.nickname || '';
          const tiktokUsername = profile.username || profile.unique_id || '';
          const tiktokProfilePic = profile.avatar_url || profile.avatar || '';
          const sanitized = res.data.map((item: any) => ({
            ...item,
            tiktok_name: tiktokName,
            tiktok_username: tiktokUsername,
            tiktok_profile_picture: tiktokProfilePic,
            title: item.title?.trim() ?? '',
            video_description: item.video_description?.trim() ?? ''
          }));
          const batch = sanitized;
          if (this.showContent) {
            this.tiktokVideos = [...this.tiktokVideos, ...batch];
            const formattedBatch = batch.map((video: any) => ({
              ...video,
              caption: video.video_description || '(sem descrição)',
              media_type: 'VIDEO',
              media_url: video.embed_html,
              thumbnail_url: video.cover_image_url,
              embed_link: video.embed_link,
              permalink: video.share_url,
              timestamp: video.create_time * 1000,
              source: 'tiktok',
              safe_player_url: this.toSafePlayer(video.embed_link),
              duration: video.duration ?? 0
            }));
            this.formattedTikTokVideos = [...this.formattedTikTokVideos, ...formattedBatch];
            this.tiktokCursor = res.paging?.next;
            this.hasMoreTikTokVideos = !!this.tiktokCursor;
          }
          // SSAPP-8: emite o acumulado formatado (igual ao InstagramGalleryComponent
          // via mergeUniqueItems), não só a página que acabou de chegar — quem escuta
          // mediaResults numa segunda página precisa do snapshot completo, não do delta.
          this.mediaResults.emit(this.formattedTikTokVideos);
          this.hasSearchedTikTok = true;
          this.displayAguarde = false;
          this.LoadSearching = false;
          this.extractedByUrl = false;
        },
        error: (error: any) => {
          this.LoadSearching = false;
          this.hasSearchedTikTok = true;
          this.displayAguarde = false;
          this.errorHandler.handle(error, error.error?.error || error.message);
          this.mediaResults.emit([]);
        }
      });
  }

  // Seleção de itens (mesma lógica que no Instagram)
  toggleSelection(item: any): void {
    const idx = this.selectedItems.findIndex(i => i.id === item.id);
    let newSelected: any[];
    if (idx >= 0) {
      newSelected = [
        ...this.selectedItems.slice(0, idx),
        ...this.selectedItems.slice(idx + 1)
      ];
    } else {
      newSelected = [...this.selectedItems, item];
    }
    this.selectedItemsChange.emit(newSelected);
  }

  isItemSelected(item: any): boolean {
    return this.selectedItems.some(i => i.id === item.id);
  }
  isSelected(item: any): boolean {
    return this.selectedItems.some(i => i.id === item.id);
  }

  @Output() openPostDialog = new EventEmitter<any>();
  openDialog(item: any) {
    this.openPostDialog.emit(item);
  }

  closePostDialog() {
    this.postDialogVisible = false;
    this.selectedPost = null;
  }

  toSafePlayer(raw: string): SafeResourceUrl {
    if (!raw) {
      return this.sanitizer.bypassSecurityTrustResourceUrl('');
    }
    try {
      const url = new URL(raw);
      return this.sanitizer.bypassSecurityTrustResourceUrl(url.toString());
    } catch {
      try {
        const fixed = raw.startsWith('//') ? `https:${raw}` :
          raw.startsWith('http') ? raw : `https://${raw}`;
        const url2 = new URL(fixed);
        return this.sanitizer.bypassSecurityTrustResourceUrl(url2.toString());
      } catch {
        return this.sanitizer.bypassSecurityTrustResourceUrl(raw);
      }
    }
  }



  collapsed: { ttMain: boolean; ttExtract: boolean } = {
    ttMain: true,
    ttExtract: true
  };

  toggle(section: 'ttMain' | 'ttExtract'): void {
    this.collapsed[section] = !this.collapsed[section];
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['isFeed']) {
      this.updateCollapsed();
    }
  }

  updateCollapsed() {
    this.collapsed.ttMain = this.isFeed ? false : true;
    this.collapsed.ttExtract = true;
  }
  // campos da extração TikTok (vamos ligar ao backend depois)
  tiktokUrl = '';
  extractingTikTok = false;

  private buildTikTokPlayerUrl(id: string): string {
    const base = `https://www.tiktok.com/player/v1/${id}`;
    const qs = new URLSearchParams({
      music_info: '1',
      description: '1',
      autoplay: '1',
      loop: '1'
    });
    return `${base}?${qs.toString()}`;
  }

  parseIsoDuration(iso: string): number {
    if (!iso) return 0;
    const match = iso.match(/^PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?$/);
    if (!match) return 0;
    const [, h, m, s] = match;
    return (parseInt(h || '0', 10) * 3600) + (parseInt(m || '0', 10) * 60) + (parseInt(s || '0', 10));
  }


  private mapTikTokExtractItemsToRaw(items: any[]): any[] {
    return (items || []).map((raw: any) => {
      const d = raw.data ?? raw;

      const id =
        d.id || d.aweme_id || raw.id || '';




      const title =
        d.title || d.desc || d.description || '';
      const video_description =
        d.video_description || d.description || d.desc || '';
      const cover_image_url =
        d.cover_image_url || d.cover || d.origin_cover || d.thumbnail || '';

      const author = d.author || {};
      const tiktok_username = author.unique_id || author.username || '';
      const tiktok_name = author.nickname || author.name || '';
      const tiktok_profile_picture = author.avatar || author.avatar_thumb || '';

      // epoch seconds (se vier publishedAt, converte)
      let create_time = d.create_time;
      if (!create_time && d.publishedAt) {
        const t = Date.parse(d.publishedAt);
        if (!Number.isNaN(t)) create_time = Math.floor(t / 1000);
      }

      const statistics = d.statistics || {};
      const play_count = Number(statistics.play_count ?? d.play_count ?? 0);
      const like_count = Number(statistics.digg_count ?? d.digg_count ?? statistics.likeCount ?? 0);
      const comment_count = Number(statistics.comment_count ?? d.comment_count ?? 0);
      const share_count = Number(statistics.share_count ?? d.share_count ?? 0);

      const share_url =
        d.share_url || (id && tiktok_username ? `https://www.tiktok.com/@${tiktok_username}/video/${id}` : '');

      // link/iframe para o player
      // 👇 aqui muda:
      const embed_link = d.embed_link || (id ? this.buildTikTokPlayerUrl(id) : null);
      const safe_player_url = this.toSafePlayer(embed_link || undefined);

      // vídeo direto (se a RapidAPI trouxer)
      const video_url = d.play || d.play_url || d.video_url || null;

      // opcional: html de embed (se quiser usar em outro lugar)
      const embed_html = embed_link
        ? `<iframe src="${embed_link}" frameborder="0" allowfullscreen></iframe>`
        : '';


      // Preferência: durationSeconds, depois duration (number), depois duration (ISO)
      let duration = null;
      if (typeof d.durationSeconds === 'number') duration = d.durationSeconds;
      else if (typeof d.duration === 'number') duration = d.duration;
      else if (typeof d.duration === 'string') duration = this.parseIsoDuration(d.duration);
      else if (d.details?.contentDetails?.duration) duration = this.parseIsoDuration(d.details.contentDetails.duration);

      return {
        // shape “raw” esperado pelo seu importarSelecionados()
        id,
        title,
        video_description,
        cover_image_url,
        create_time,
        share_url,
        embed_html,
        video_url,
        tiktok_username,
        tiktok_name,
        tiktok_profile_picture,
        like_count,
        comment_count,
        share_count,
        play_count,

        // campos usados no seu DataView
        media_type: 'VIDEO',
        media_url: embed_html,           // você usa isso em alguns lugares
        thumbnail_url: cover_image_url,  // idem
        embed_link,
        permalink: share_url,
        timestamp: create_time ? create_time * 1000 : undefined,
        source: 'tiktok',
        safe_player_url,
        duration
      };
    });
  }
  extractedByUrl: boolean = false;
  extractTikTok(reset = false) {
    if (!this.tiktokUrl) return;

    if (reset) {
      this.tiktokVideos = [];
      this.formattedTikTokVideos = [];
      this.tiktokCursor = undefined;
      this.hasMoreTikTokVideos = false;
      this.hasSearchedTikTok = false;
    }

    this.extractingTikTok = true;

    this.tiktokService.extractTikTokByUrlPublic(this.tiktokUrl).subscribe({
      next: (res) => {
        const raw = this.mapTikTokExtractItemsToRaw(res.items || []);

        if (this.showContent) {
          // Preenche as duas coleções, como no loadMoreTikTokVideos
          this.tiktokVideos = [...this.tiktokVideos, ...raw];
          const formattedBatch = raw.map(video => ({
            ...video,
            caption: video.video_description || '(sem descrição)',
            // já tenho os campos necessários acima; só garanto o safe_player_url:
            safe_player_url: video.safe_player_url ?? this.toSafePlayer(video.embed_link)
          }));
          this.formattedTikTokVideos = [...this.formattedTikTokVideos, ...formattedBatch];
          this.hasMoreTikTokVideos = false; // extração por URL é 1 item
        } else {
          // quando estiver em modo “retornar resultados”
          this.mediaResults.emit(raw);
        }

        this.hasSearchedTikTok = true;
        this.extractedByUrl = true;

        if (!this.formattedTikTokVideos.length && !raw.length) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Nada encontrado',
            detail: 'Não foi possível extrair conteúdo dessa URL.'
          });
        }

        this.extractingTikTok = false;

      },
      error: (error) => {
        this.extractingTikTok = false;
        this.errorHandler.handle(error, 'Falha ao extrair o vídeo do TikTok.');
        this.mediaResults.emit([]);
      }
    });
  }


  tiktokInvalid: boolean = false;
  tiktokRegex = /^(https?:\/\/)?(www\.)?tiktok\.com\/(@[\w\.]+\/video\/\d+|v\/\d+|embed\/\d+|[\w\-]+\/video\/\d+)\/?(\?.*)?$/i;

  checkTiktokUrl() {
    this.tiktokInvalid = !!this.tiktokUrl && !this.tiktokRegex.test(this.tiktokUrl.trim());
  }

}
